import React, { useState } from "react";
import { login } from "./api";

export default function Login({ onLogin }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!username || !password) return;
    setBusy(true);
    setError("");
    try {
      await login(username, password);
      onLogin();
    } catch (err) {
      setError(err.message || "Sisselogimine ebaõnnestus");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        backgroundColor: "#F3F6FD",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontFamily: "'DM Sans', sans-serif",
      }}
    >
      <div
        style={{
          width: "340px",
          padding: "30px",
          backgroundColor: "white",
          borderRadius: "14px",
          boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
        }}
      >
        <h2
          style={{
            textAlign: "center",
            marginBottom: "20px",
            fontWeight: 700,
            color: "#0D1F4D",
          }}
        >
          Bioforce raportite Login
        </h2>

        <form onSubmit={handleSubmit}>
          <label style={{ fontWeight: 600, color: "#0D1F4D" }}>Kasutajanimi</label>
          <input
            type="text"
            placeholder="kasutajanimi"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            style={{
              width: "100%",
              padding: "10px",
              marginTop: "6px",
              marginBottom: "18px",
              borderRadius: "8px",
              border: "1px solid #8CA5E6",
              fontSize: "14px",
              fontFamily: "'DM Sans', sans-serif",
            }}
          />

          <label style={{ fontWeight: 600, color: "#0D1F4D" }}>Salasõna</label>
          <input
            type="password"
            placeholder="••••••••"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={{
              width: "100%",
              padding: "10px",
              marginTop: "6px",
              marginBottom: "10px",
              borderRadius: "8px",
              border: "1px solid #8CA5E6",
              fontSize: "14px",
              fontFamily: "'DM Sans', sans-serif",
            }}
          />

          <div style={{ textAlign: "right", marginBottom: "20px" }}>
            <span
              style={{
                color: "#8CA5E6",
                fontSize: "14px",
                cursor: "pointer",
              }}
              onClick={() => alert("Reset password flow will be added")}
            >
              Unustasid salasõna?
            </span>
          </div>

          {error && (
            <div
              style={{
                background: "#FDECEA",
                border: "1px solid #F5C6C0",
                color: "#C0392B",
                borderRadius: "8px",
                padding: "10px 12px",
                fontSize: "13px",
                marginBottom: "14px",
                fontWeight: 600,
              }}
            >
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={busy}
            style={{
              width: "100%",
              padding: "12px",
              backgroundColor: busy ? "#9AA8C7" : "#0D1F4D",
              color: "white",
              border: "none",
              borderRadius: "8px",
              fontWeight: 700,
              fontSize: "15px",
              fontFamily: "'DM Sans', sans-serif",
              cursor: busy ? "not-allowed" : "pointer",
              transition: "0.2s",
            }}
          >
            {busy ? "Login sisse…" : "Logi sisse"}
          </button>
        </form>
      </div>
    </div>
  );
}